// extracted by mini-css-extract-plugin
export default {"imageContainer":"Whatsapp_imageContainer__TZEeU"};